export const SKIP_REASON_OPTIONS = [
  { value: '', label: 'Tümü' },
  { value: 'MEMBER_LOGO_CARI_MISSING', label: 'Logo cari eksik' },
  { value: 'LOGO_CUSTOMER_NOT_FOUND', label: 'Logo cari bulunamadı' },
  { value: 'LOGO_ERP_UNREACHABLE', label: 'Logo erişim/oturum' },
  { value: 'CONFIG_MISSING', label: 'Yapılandırma eksik' },
  { value: 'UNIT_PRICE_NOT_CONFIGURED', label: 'Birim fiyat yok' },
  { value: 'LOGO_POST_FAILED', label: 'Logo fiş hatası' },
  { value: 'MEMBER_NOT_FOUND', label: 'Üye bulunamadı' },
  { value: 'LOGO_INCOME_ACCOUNT_NOT_FOUND', label: 'Gelir hesabı (fiş)' },
];

export const getSkipReasonLabel = (code) =>
  SKIP_REASON_OPTIONS.find((o) => o.value === code)?.label || code || '-';

export const CAP_EVENT_LABELS = {
  'meeting.meal.attended': 'Toplantı katılımı',
  'meeting.meal.registered': 'Toplantı kaydı (eş/misafir)',
};

export const getCapEventLabel = (name) => CAP_EVENT_LABELS[name] || name || '-';
